/** Etichetta UI da valore `compliant`: true → Conforme, false → Non conforme, null → vuoto. */
export function getTicketComplianceDisplay(
  t: (key: string) => string,
  compliant: boolean | null | undefined
): string {
  const prefix = 'pages.tickets.compliance_options';

  if (compliant === true) {
    return t(`${prefix}.compliant`);
  }
  if (compliant === false) {
    return t(`${prefix}.non-compliant`);
  }
  return '';
}
